import React from "react";
import { COMPANY } from "@/lib/api";
import { Target, Award, Users, MapPin } from "lucide-react";

export default function About() {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14" data-testid="about-page">
      <div className="grid lg:grid-cols-2 gap-12 items-center">
        <div>
          <div className="eyebrow">About us</div>
          <h1 className="font-heading text-4xl sm:text-5xl font-bold text-[#0A192F] mt-3">Reliable GPS technology, engineered in India.</h1>
          <p className="mt-5 text-slate-600 leading-relaxed">
            {COMPANY.name} is a Jaipur-based technology company delivering GPS tracking devices, fleet management solutions, subscription plans, installation and technical support for businesses across India. We help owners of personal vehicles, transporters, schools, logistics companies and enterprise fleets track, manage and protect their vehicles with confidence.
          </p>
          <p className="mt-4 text-slate-600 leading-relaxed">
            Our team combines local expertise with modern GPS hardware and cloud dashboards so you get accurate real-time data, reliable alerts and hands-on service — in Hindi and English.
          </p>
        </div>
        <div className="aspect-video rounded-2xl overflow-hidden bg-slate-100">
          <img src="https://images.unsplash.com/photo-1594852352010-63d76b89f85f?w=1200&q=80" alt="Fleet operations" className="w-full h-full object-cover" />
        </div>
      </div>

      <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {[
          { icon: Target, title: "Our Mission", desc: "Make Indian roads safer and every vehicle more productive." },
          { icon: Award, title: "Quality First", desc: "Rigorous testing on Indian networks and vehicle conditions." },
          { icon: Users, title: "Customer Focus", desc: "Local support, transparent pricing, honest advice." },
          { icon: MapPin, title: "Based in Jaipur", desc: "Pan-India delivery, installation and service network." },
        ].map((it) => (
          <div key={it.title} className="p-6 rounded-2xl border border-slate-200 bg-white">
            <div className="w-11 h-11 rounded-xl bg-[#FF6D00]/10 text-[#FF6D00] flex items-center justify-center">
              <it.icon className="w-5 h-5" />
            </div>
            <h3 className="font-heading font-semibold text-[#0A192F] mt-4">{it.title}</h3>
            <p className="text-sm text-slate-600 mt-1.5">{it.desc}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
